/**
 * Post Purchases Utility Functions
 * Pure functions for post-purchase offer data manipulation
 */

import type {
    PostPurchaseOffer,
    PostPurchaseOfferItem,
    PostPurchaseOfferSummary,
} from '../resources/postPurchases';

// Re-export types from resources for convenience
export type {
    PostPurchaseOffer,
    PostPurchaseOfferItem,
    PostPurchaseOfferSummary,
};

export class PostPurchasesUtils {
    /**
     * Check if post-purchase offer is valid
     */
    static isValidOffer(offer: PostPurchaseOffer): boolean {
        return !!(offer.id && offer.summaries && offer.summaries.length > 0);
    }

    /**
     * Get offer total amount
     */
    static getOfferTotal(offer: PostPurchaseOffer): number {
        return offer.summaries?.[0]?.totalAmount || 0;
    }

    /**
     * Get offer adjusted total
     */
    static getOfferAdjustedTotal(offer: PostPurchaseOffer): number {
        return offer.summaries?.[0]?.totalAdjustedAmount || 0;
    }

    /**
     * Check if offer has items
     */
    static hasItems(offer: PostPurchaseOffer): boolean {
        return !!(offer.offerLineItems && offer.offerLineItems.length > 0);
    }

    /**
     * Get offer currency
     */
    static getOfferCurrency(offer: PostPurchaseOffer): string {
        return offer.summaries?.[0]?.currency || 'USD';
    }

    /**
     * Get offer title
     */
    static getOfferTitle(offer: PostPurchaseOffer, locale = 'en'): string {
        return offer.titleTrans?.[locale] || offer.titleTrans?.en || `Offer ${offer.id}`;
    }
}
